import { useContext } from "react";
// import slide1 from "../assets/1.png";
// import slide2 from "../assets/2.png";
import mobile1 from "../assets/RCI-Website-banner---480x60-Pixel-02.jpg";
import mobile2 from "../assets/CC-Website-banner---480x60-Pixel-03.jpg";
import mobile3 from "../assets/CC-Website-banner---480x60-Pixel-04.jpg";
import mobile4 from "../assets/weekendAlaskaMobile.png";
// import mobile4 from "../assets/IndSlideMob.png"
import slide1 from "../assets/RCI-Website-Banner.jpg";
import slide2 from "../assets/CC-Website-Banner-01.jpg";
import slide3 from "../assets/weekendAlaskaDesktop.png";
// import slide3 from "../assets/IndSlideWeb.png";

// import slide3 from "../assets/tirun_HNS_Banner.jpeg";
// import slide3 from "../assets/3.png";
// import slide4 from "../assets/4.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import SearchWidget from "./SearchWidget";
import "../style.css";
import { CurrencyContext } from "./CurrencyContext";
// import { Link } from "react-router-dom";

const dlink = {

  mbanner1: {
    USD: "https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc",
    INR: "https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=8&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc"
  },
  mbanner2: {
    USD: "https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc",
    INR: "https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc"
  },
  mbanner3: {
    USD: "https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc",
    INR: "https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc"
  },
  mbanner4:{
    USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&destinations=1&sortcolumn=departureDate&sortorder=asc&_gl=1*18ywzrv*_ga*MjgwNjA1NTkzLjE3NTQ2MzUwNjE.*_ga_PBH0ZZNRGB*czE3NTU4NjUyNzkkbzM3JGcxJHQxNzU1ODY1MzAwJGozOSRsMCRoMTk3MTMwNTMyNA..&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_term=undefined&matchtype=undefined&device=undefined&utm_content=undefined&utm_adgroup=undefined",
    INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=2&destinationtype=All&destinations=1&sortcolumn=departureDate&sortorder=asc&_gl=1*wsvjac*_ga*MTIwMjg2MjA5My4xNzU1NDkyNDk1*_ga_PBH0ZZNRGB*czE3NTU4NjUxMDIkbzIxJGcxJHQxNzU1ODY1NzQyJGo0JGwwJGg3MzgxNTMxMjA.&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_term=undefined&matchtype=undefined&device=undefined&utm_content=undefined&utm_adgroup=undefined"
  },
  lbanner1: {
    USD: "https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc",
    INR: "https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=8&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc"
  },
  lbanner2: {
    USD: "https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc",
    INR: "https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc"
  },
   lbanner3:{
    USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&destinations=1&sortcolumn=departureDate&sortorder=asc&_gl=1*18ywzrv*_ga*MjgwNjA1NTkzLjE3NTQ2MzUwNjE.*_ga_PBH0ZZNRGB*czE3NTU4NjUyNzkkbzM3JGcxJHQxNzU1ODY1MzAwJGozOSRsMCRoMTk3MTMwNTMyNA..&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_term=undefined&matchtype=undefined&device=undefined&utm_content=undefined&utm_adgroup=undefined",
    INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=2&destinationtype=All&destinations=1&sortcolumn=departureDate&sortorder=asc&_gl=1*wsvjac*_ga*MTIwMjg2MjA5My4xNzU1NDkyNDk1*_ga_PBH0ZZNRGB*czE3NTU4NjUxMDIkbzIxJGcxJHQxNzU1ODY1NzQyJGo0JGwwJGg3MzgxNTMxMjA.&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_term=undefined&matchtype=undefined&device=undefined&utm_content=undefined&utm_adgroup=undefined"
  } 

}

const Header = () => {

  const Currency = useContext(CurrencyContext);

  return (
    <>
      <div className="header">
        <div className="offer-alert">
          <div>
            <FontAwesomeIcon icon={faStar} style={{ color: "#f0ad4e", marginLeft: '5px' }} />
            <FontAwesomeIcon icon={faStar} style={{ color: "#f0ad4e", marginLeft: '5px' }} />
            <FontAwesomeIcon icon={faStar} style={{ color: "#f0ad4e", marginLeft: '5px' }} />
            <FontAwesomeIcon icon={faStar} style={{ color: "#f0ad4e", marginLeft: '5px' }} />
            <FontAwesomeIcon icon={faStar} style={{ color: "#f0ad4e", marginLeft: '5px' }} />
          </div>
          <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
        </div>

        {/* mobile responsive */}

        <div id="carouselExampleIndicators2" class="carousel slide  mobile-header" data-bs-ride="carousel" data-bs-interval="4000">

          {/* <div className="header-image">
 <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <img src={slide3} alt="Royal Caribbean" style={{cursor:'pointer'}}/></a>
 </div> */}
          {/* <div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
          {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

          {/* </div> */}
          <div class="carousel-inner ">
            {/* <div class="carousel-item mobile active">
<a href={dlink.mbanner4[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
<img src={mobile4} class="d-block w-100 ImobileSlide" alt="..."/>
</a>
</div> */}
            <div class="carousel-item">
              <a href={dlink.mbanner1[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
                <img src={mobile1} class="d-block w-100 ImobileSlide " alt="..." />
              </a>
            </div>
            <div class="carousel-item ">
              <a href={dlink.mbanner2[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
                <img src={mobile2} class="d-block w-100 ImobileSlide" alt="..." />
              </a>
            </div>
            {/* <div class="carousel-item mobile"> */}
            <div class="carousel-item">
              <a href={dlink.mbanner3[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
                <img src={mobile3} class="d-block w-100 ImobileSlide" alt="..." />
              </a>
            </div>

            <div class="carousel-item active">
              <a href={dlink.mbanner4[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
                <img src={mobile4} class="d-block w-100 ImobileSlide" alt="..." />
              </a>
            </div>
            {/* <div class="carousel-item mobile">
<a href={dlink.mbanner4[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
<img src={mobile4} class="d-block w-100 ImobileSlide" alt="..."/>
</a>
</div> */}


            {/* <div class="carousel-item mobile">
<img src={mobile4} class="d-block w-100" alt="..."/>
</div> */}
          </div>

          {/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
        </div>

        <div class="ajslider ">
          <div id="carouselExampleIndicators" class="carousel slide ajslider-container laptop-header" data-bs-ride="carousel" data-bs-interval="2000">

            {/* <div className="header-image">
            <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <img src={slide3} alt="Royal Caribbean" style={{cursor:'pointer'}}/></a>
            </div> */}
            {/* panel */}
            <div class="carousel-indicators" >
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
              {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 3"></button> */}
              <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
              {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

            </div>
            <div class="carousel-inner laptop-responsive">

              {/* <div class="carousel-item  ">
      <Link to="/singapore">
      <img src={slide3} class="d-block w-100" alt="..."/>
      </Link>
    </div> */}
              {/* <div class="carousel-item active">
    <a href={dlink.lbanner3[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
      <img src={slide3} class="d-block w-100 IwebSlide" alt="..."/>
      </a>
    </div> */}

              <div class="carousel-item active ">
                <a href={dlink.lbanner3[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
                  <img src={slide3} class="d-block w-100 " alt="Alaska Weekend Sale" />
                </a>
              </div>

              <div class="carousel-item">
                <a href={dlink.lbanner1[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
                  <img src={slide1} class="d-block w-100 " alt="..." />
                </a>
              </div>

              <div class="carousel-item ">
                <a href={dlink.lbanner2[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
                  <img src={slide2} class="d-block w-100 " alt="..." />
                </a>
              </div>

              {/* <div class="carousel-item mobile">
      <img src={mobile2} class="d-block w-100" alt="..."/>
    </div> */}
            </div>


            {/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button> */}
          </div>


          <div className="SearchCruise">
            <h2>Search For Cruise</h2>
            <SearchWidget />
          </div>

        </div>

      </div>

    </>
  );
}

export default Header;